import { Slot } from '@blocksuite/global/utils';
import type { SerializedAttendee, SerializedTodoItem } from '@pique/core/modules/properties/services/schema';
import type { TranscriptChunkData } from '@pique/core/services/transcription-service';

// Core media control slots - still used by audio/video components
export const seekVideoSlot = new Slot<number>();
export const pauseMediaSlot = new Slot<void>();
export const videoCompletedSlot = new Slot<boolean>();

// User interaction slots - still used for marking transcription content
export const handRaiseTaSlot = new Slot<void>();
export const markImportantSlot = new Slot<void>();
export const confusedSlot = new Slot<void>();

// Live chat and transcription UI slots
export const paragraphBlockAddedSlot = new Slot<string>();
export const seekTranscriptionAtTimestampSlot = new Slot<string>();
export const scrollTranscriptToBottomSlot = new Slot<void>();

// Mindmap and meeting-specific slots
export const actionItemSelectedSlot = new Slot<{
  attendee: SerializedAttendee;
  actionItem: SerializedTodoItem;
}>();
export const attendeeActionsPanelOpenedSlot = new Slot<void>();
export const recordingStartedSlot = new Slot<void>();

// Central transcription service slot - used by transcription service
export const latestTranscriptionChunkSlot = new Slot<TranscriptChunkData>();

// Action item prioritization slot
export const prioritizeActionItemsSlot = new Slot<void>();

export const openActionItemInKanbanSlot = new Slot<{
  pageId: string;
  itemId: string;
}>();

export const highlightLinkedBlocksSlot = new Slot<{
  timestamps: string[];
  mindmapNodeId: string;
}>();

export type ProTipPlacement =
  | 'top'
  | 'top-start'
  | 'top-end'
  | 'bottom'
  | 'bottom-start'
  | 'bottom-end'
  | 'left'
  | 'left-start'
  | 'left-end'
  | 'right'
  | 'right-start'
  | 'right-end';

export const proTipIconNames = [
  'lightMode',
  'info',
  'informationFillDuotone',
  'help',
  'helpCenter',
  'ai',
  'new',
  'favorite',
] as const;

export type ProTipIconName = (typeof proTipIconNames)[number] | 'none';

export type ProTipOffset =
  | number
  | {
      mainAxis?: number;
      crossAxis?: number;
      alignmentAxis?: number;
    };

export interface ProTipConfig {
  id: string;
  targetSelector?: string;
  targetElement?: HTMLElement;
  title?: string;
  content: string;
  placement?: ProTipPlacement;
  offset?: ProTipOffset;
  autoHideDelay?: number;
  showCloseButton?: boolean;
  icon?: ProTipIconName;
}

export const showProTipSlot = new Slot<ProTipConfig>();
export const hideProTipSlot = new Slot<string>();
